<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/',title:'首页'},{title:'损益信息表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">


            <!-- <el-switch
                    @click="choosetou"
                    v-model="moretou"
                    active-text="增加损益"
					 style="margin-bottom: 0.2rem;"
                    inactive-text="">
            </el-switch> -->


            <!--表单-->
            <div class="h-formLine" v-if="moretou" style="margin: 0.2rem 0;">
				<div class="h-piece">
				    <div class="h-formBox">
						<el-form ref="form" :model="zengjia"
								 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">


							<el-form-item label="日期" prop="periodCode" :rules="[
										  { required: true, message: '请输入日期名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.periodCode"></el-input>
							</el-form-item>
							<el-form-item label="科目编码" prop="actCode" :rules="[
										  { required: true, message: '请输入科目编码名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.actCode"></el-input>
							</el-form-item>
							<el-form-item label="科目名称" prop="actName" :rules="[
										  { required: true, message: '请输入科目名称名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.actName"></el-input>
							</el-form-item>
							<el-form-item label="型号编码" prop="matCode" :rules="[
										  { required: true, message: '请输入型号编码名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.matCode"></el-input>
							</el-form-item>
							<el-form-item label="型号名称" prop="matName" :rules="[
										  { required: true, message: '请输入型号名称名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.matName"></el-input>
							</el-form-item>
							<el-form-item label="产品编码" prop="prodCode" :rules="[
										  { required: true, message: '请输入产品编码名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.prodCode"></el-input>
							</el-form-item>
							<el-form-item label="产品名称" prop="prodName" :rules="[
										  { required: true, message: '请输入产品名称名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.prodName"></el-input>
							</el-form-item>
							<el-form-item label="区域编码" prop="regionCode" :rules="[
										  { required: true, message: '请输入区域编码名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.regionCode"></el-input>
							</el-form-item>
							<el-form-item label="区域名称" prop="regionName" :rules="[
										  { required: true, message: '请输入区域名称名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.regionName"></el-input>
							</el-form-item>
							<el-form-item label="大区域:  国内 / 海外" prop="regionCode2" :rules="[
										  { required: true, message: '请输入大区域:  国内 / 海外名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.regionCode2"></el-input>
							</el-form-item>
							<el-form-item label="版本:  年累计 / 月累计" prop="versionCode" :rules="[
										  { required: true, message: '请输入版本:  年累计 / 月累计名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.versionCode"></el-input>
							</el-form-item>
							<el-form-item label="显示平台来源表(来自哪个表的数据)" prop="sourceCode" :rules="[
										  { required: true, message: '请输入显示平台来源表(来自哪个表的数据)名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.sourceCode"></el-input>
							</el-form-item>
							<el-form-item label="数值" prop="nValue" :rules="[
										  { required: true, message: '请输入数值名称', trigger: 'blur'},
										]" class="h-elformWrap-1">
								<el-input v-model="zengjia.nValue"></el-input>
							</el-form-item>

							<div class="h-formBtnOut" style="display: flex;justify-content: center;align-items: center;">
								<el-button class="h-btn h-formBtn" @click="zengjiasunyi">增加</el-button>
							</div>


						</el-form>
					</div>
				</div>
			</div>


            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="科目编码">
							    <el-input v-model="q.actCode"></el-input>
							</el-form-item>
							<el-form-item label="日期">
							    <el-input v-model="q.periodCode"></el-input>
							</el-form-item>
							<el-form-item label="科目名称">
							    <el-input v-model="q.actName"></el-input>
							</el-form-item>
							<el-form-item label="型号编码">
								<el-input v-model="q.matCode"></el-input>
							</el-form-item>
						</div>	
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="型号名称">
										<el-input v-model="q.matName"></el-input>
									</el-form-item>
									<el-form-item label="产品编码" >
										<el-input v-model="q.prodCode"></el-input>
									</el-form-item>
									<el-form-item label="产品名称">
										<el-input v-model="q.prodName"></el-input>
									</el-form-item>
									<el-form-item label="区域编码">
										<el-input v-model="q.regionCode"></el-input>
									</el-form-item>
								</div>	
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="区域名称">
										<el-input v-model="q.regionName"></el-input>
									</el-form-item>
									<el-form-item label="是否改数" >
										<brselect clearable category="shifou_keyong" :v="q.caiwugaishu"
												  v-model="q.caiwugaishu"></brselect>
									</el-form-item>
									<el-form-item label="大区域">
										<brselect clearable category="guoneihaiwai_cesuan" :v="q.regionCode2"
												  v-model="q.regionCode2"></brselect>
									</el-form-item>
									<el-form-item label="版本累计">
										<brselect clearable category="nianyue_cesuan" :v="q.versionCode"
										  v-model="q.versionCode"></brselect>
									</el-form-item>
								</div>
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="更新时间">
										<el-col :span="11"  style="width: 100%;">
											<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
													v-model="q.ldate" style="width: 100%;"></el-date-picker>
										</el-col>
									</el-form-item>
									<el-form-item label="数值">
										<el-input v-model="q.nValue"></el-input>
									</el-form-item>
									<el-form-item label="　修改人编码">
										<el-input v-model="q.lucode"></el-input>
									</el-form-item>	
									<el-form-item label="显示平台来源表(来自哪个表的数据)">
										<el-input v-model="q.sourceCode"></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
						
						<!-- <div class="h-formBtnOut h-columnCenter">
						    <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div> -->
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
						</div>
					</div>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        style="width: 100%"
						:border="true"
						max-height="500"
                >

					<el-table-column
					type="selection"
					width="40"
					fixed
					>
					</el-table-column>
                    <el-table-column
                            prop="id"
                            label="id"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="periodCode"
                            label="日期"
							:show-overflow-tooltip="true"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="actCode"
                            label="科目编码"
							:show-overflow-tooltip="true"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="actName"
                            label="科目名称"
							:show-overflow-tooltip="true"
                            min-width="90">
                    </el-table-column>
                    <el-table-column
                            prop="matCode"
                            label="型号编码"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="matName"
                            label="型号名称"
							:show-overflow-tooltip="true"
                            width="180">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.matName}}
								</div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="prodCode"
                            label="产品编码"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="prodName"
                            label="产品名称"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="regionCode"
                            label="区域编码"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="regionName"
                            label="区域名称"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="regionCode2"
                            label="国内/海外"
							:show-overflow-tooltip="true"
                            width="100">

                        <template slot-scope="scope">
                            <dictname category="guoneihaiwai_cesuan" :v="scope.row.regionCode2"/>
                        </template>

                    </el-table-column>
                    <el-table-column
                            prop="versionCode"
                            label="年累计/月累计"
							:show-overflow-tooltip="true"
                            width="130">
                    </el-table-column>
                    <el-table-column
                            prop="sourceCode"
                            label="来自哪个表的数据"
							:show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
                    <el-table-column
                            prop="nvalue"
                            label="数值"
							:show-overflow-tooltip="true"
                            width="100">
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.nvalue}}
								</div>
							</template>
                    </el-table-column>

                    <el-table-column
                            prop="caiwugaishu"
                            label="是否改数"
							:show-overflow-tooltip="true"
                            width="90">

                        <template slot-scope="scope">
                            <dictname category="shifou_keyong" :v="scope.row.caiwugaishu"/>
                        </template>

                    </el-table-column>

                    <el-table-column
                            prop="ldate"
                            label="最后更新时间"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="lucode"
                            label="修改人编码"
							:show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>


                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100"
                    >
                        <template slot-scope="scope">
							<div style="text-align: left;">
								<el-button
										size="small" class="h-tableLink h-btn"
								        @click="xiigaishuzhi(scope.row)">修改数值
								</el-button>
							</div>
                            
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-xg" title="修改数值" @click="xiigaishuzhi(scope.row)"></span>
							</div> -->
<!--                            <el-button-->
<!--                                    size="mini"-->
<!--                                    type="danger"-->
<!--                                    @click="shanchusunyi(scope.row)">删除-->
<!--                            </el-button>-->
                        </template>
                    </el-table-column>

                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query"/>

                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:0;" @click="outexcel">批量导出
                    </el-button>

                </div>
            </div>
        </div>


        <!-- 修改数值 -->
        <el-dialog :visible.sync="kaishixiugai" class="h-dialog2" :show-close="true" :close-on-click-modal="false">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>修改数值</h1>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-input v-model="xiugainvalue" placeholder="请输入.xxx" @blur="xiugaichange(xiugainvalue)"
                    ></el-input>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="quedingxiugai">确定</el-button>
                    </div>

                </div>

            </div>

        </el-dialog>


    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import updownfile from '../../../utils/updownfile';

    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),

                moretou: false,

                zengjia: {},

                moreCondition: false,

                //被修改的id
                xiugaiindex: '',

                //要修改的值
                xiugainvalue: '',

                kaishixiugai: false,

                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    periodCode:"",
                    actCode:"",
                    actName:"",
                    matCode: "", // 型号编码
                    matName: "", // 型号名称
                    prodCode: "", // 产品编码
                    prodName: "", // 产品名称
                    regionCode: "", // 区域编码
                    regionName: "", // 区域名称
                    regionCode2: "", // 大区域:  国内 / 海外
                    versionCode: "", // 版本:  年累计 / 月累计
                    sourceCode: "", // 显示平台来源表(来自哪个表的数据)
                    nValue: "", // 数值
                    caiwugaishu:"",
                    lucode:"",
                    ldate:"",
                },


                //表单
                zengjia: {

                    periodCode: null, // 日期
                    actCode: null, // 科目编码
                    actName: null, // 科目名称
                    matCode: null, // 型号编码
                    matName: null, // 型号名称
                    prodCode: null, // 产品编码
                    prodName: null, // 产品名称
                    regionCode: null, // 区域编码
                    regionName: null, // 区域名称
                    regionCode2: null, // 大区域:  国内 / 海外
                    versionCode: null, // 版本:  年累计 / 月累计
                    sourceCode: null, // 显示平台来源表(来自哪个表的数据)
                    nValue: null, // 数值

                },


                //table列表
                tableData: [],


                //操作标志
                optflag: 'save',


            }
        },


        created() {
            this.query();
        },


        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},


            choosetou() {
                if (this.moretou) {
                    this.moretou = false;
                } else {
                    this.moretou = true;
                }
            },


            xiugaichange(v) {
                // if(/^0.\d+$/.test(v) == false){
                if (/^\d+(\.\d+)?$/.test(v) == false) {
                    this.$msg.msge('请输入数字或小数')
                    this.xiugainvalue = ''
                } else {
                    console.log(v)
                    return
                }
            },


            //循环判断
            xunhuanpanduan() {

                var yes = true;

                for (var d in this.zengjia) {

                    if ((this.zengjia[d] == null || this.zengjia[d] == '') && this.zengjia[d] != 0) {

                        yes = false;

                    }

                }

                return yes

            },


            //删除损益
            shanchusunyi(q) {


                this.$msg.confirm("确认删除?", () => {

                    var entity = {

                        id: q.id,
                        delflag: 0,

                    }

                    ss.FormulaNew.sunyiluojishanchu(entity).then(rd => {

                        console.log(rd,'rd')

                        if(rd.f==true){

                            this.handleFilter();

                        }

                    })


                });


            },


            //增加损益
            zengjiasunyi() {

                if (this.xunhuanpanduan() == true) {

                    ss.FormulaNew.xinzengsunyi(this.zengjia).then(rd => {

                        console.log(rd, 'rd');

                        if (rd.f == true) {

                            this.$msg.msgs("增加成功")
                            this.zengjia = {};
                            this.moretou = false;

                        }

                    })

                } else {

                    this.$msg.msge("请补充完整信息");

                }

            },

            chooseModify() {
                if (this.moreCondition) {
                    this.moreCondition = false;
                } else {
                    this.moreCondition = true;
                }
            },


            panduanxiaoshu() {

                var d = true;


                if (this.xiugainvalue && ((/^[0-9].\d+$/.test(this.xiugainvalue) == false) && parseFloat(this.xiugainvalue) != 0)) {

                    this.$msg.msge("请输入数字")

                    d = false;

                } else {

                    d = true;

                }

                return d;

            },


            //确定要修改
            quedingxiugai() {

                this.$confirm('确认修改？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {


                        //是数的话
                        var s = this.panduanxiaoshu();


                        if (s == true) {

                            var entity = {

                                id: this.xiugaiindex,
                                nValue: this.xiugainvalue,

                            }

                            //更新值
                            ss.FormulaNew.caozuobiaoupdateById(entity).then(rd => {

                                //如果成功
                                if (rd.f == true) {

                                    //更新值
                                    this.dongtaishezhi();

                                    //关窗
                                    this.kaishixiugai = false;

                                }

                            })

                        }


                    })
                    .catch(_ => {

                    });


            },

            //更新值
            dongtaishezhi() {

                this.query();

            },

            //导表
            outexcel() {

                //ss.FormulaNew.downloadExcel();
                updownfile.down("/api/swyl/v1/sunyicaozuobiao/rateSunyicaozuobiao/downloadExcel",this.q);

            },


            //修改nvalue值
            xiigaishuzhi(q) {

                console.log(q, 'aaa')

                this.kaishixiugai = true;

                this.xiugainvalue = q.nValue;

                this.xiugaiindex = q.id;

            },

             // 重置按钮
            resetData() {
                this.q.periodCode = "";
                this.q.actCode = "";
                this.q.actName = "";
                this.q.matCode = "";// 型号编码
                this.q.matName = "";// 型号名称
                this.q.prodCode = ""; // 产品编码
                this.q.prodName = ""; // 产品名称
                this.q.regionCode = ""; // 区域编码
                this.q.regionName = ""; // 区域名称
                this.q.regionCode2 = ""; // 大区域:  国内 / 海外
                this.q.versionCode =  "";// 版本:  年累计 / 月累计
                this.q.sourceCode =  ""; // 显示平台来源表(来自哪个表的数据)
                this.q.nValue =  "";// 数值
                this.q.caiwugaishu = "";
                this.q.lucode = "";
                this.q.ldate = "";
                this.q.pageSize = 10;
                this.query();
                 
            },

            query() {

                ss.FormulaNew.caozuobiaoselectPage(this.q).then(rd => {

                    this.q.total = rd.total;
                    this.tableData = rd.records;

                })
            },


            handleFilter() {

                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;

                this.query();
            },


        }
    }
</script>